import * as timestamp_pb from "google-protobuf/google/protobuf/timestamp_pb";
import { convertTimestamp } from "../../util";
import { getMetaData } from "../../api/index";
import { ROLES, LO_STO } from "../../util/constants";
import { AUTHER_CLIENT, getRequestMetadata } from "../index";
const { GetUsersRequest, UpsertUserRequest, User } = require("../../protos/auther_pb");

const getCurrentUser = () => {
  const request = new GetUsersRequest();

  const email = window.localStorage.getItem(LO_STO.USER_EMAIL) || getMetaData().email;
  const organizationId = window.localStorage.getItem(LO_STO.ORG_ID) || getMetaData().orgId;

  request.setOrganizationId(organizationId);
  request.setEmailsList([email]);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.getUsers(request, getRequestMetadata(), (err, response) => {
      if (err) {
        console.warn("getUsers", err.code, err.message);
        window.localStorage.setItem(LO_STO.USER_ROLE, ROLES.VIEWER);
        reject(err);
      } else {
        const users = response.u[0].map((userRes) => convertUserFromProto(userRes));
        const currentUser = users[0];
        const currentUserRole = currentUser?.role || ROLES.VIEWER;
        currentUser && window.localStorage.setItem(LO_STO.CURRENT_USER, JSON.stringify(currentUser));
        currentUserRole && window.localStorage.setItem(LO_STO.USER_ROLE, currentUserRole);

        resolve(currentUser);
      }
    });
  });
};

const getUsers = ({ organizationId, userIds, emails }) => {
  const request = new GetUsersRequest();
  request.setOrganizationId(organizationId);
  userIds && request.addIds(userIds);
  emails && request.addEmails(emails);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.getUsers(request, getRequestMetadata(), (err, response) => {
      if (err) {
        console.warn("getUsers", err.code, err.message);
        reject(err);
      } else {
        const users = response.u[0].map((userRes) => convertUserFromProto(userRes));

        const orgUserMap = JSON.stringify(
          users.reduce(function (r, e) {
            r[e.id] = e;
            return r;
          }, {})
        );

        window.localStorage.setItem(`org-users-${organizationId}`, orgUserMap);
        resolve(users);
      }
    });
  });
};

const getCachedUsers = async ({ organizationId }) => {
  const localStorageVal = window.localStorage.getItem(`org-users-${organizationId}`);
  if (localStorageVal) {
    return JSON.parse(localStorageVal);
  } else {
    await getUsers({ organizationId });
    const localStorageVal = window.localStorage.getItem(`org-users-${organizationId}`);
    return JSON.parse(localStorageVal);
  }
};

const createUser = ({ firstName, middleName, lastName, email, role, organizationId, id }) => {
  const request = new UpsertUserRequest();

  const user = new User();
  user.setFirstName(firstName);
  user.setMiddleName(middleName);
  user.setLastName(lastName);
  user.setEmail(email);
  user.setId(id);

  user.setRole(convertRoleToProto(role));
  user.setOrganizationId(organizationId);

  const ts = new timestamp_pb.Timestamp();
  ts.setSeconds(2);
  ts.setNanos(0);

  user.setCreatedAt(ts);
  user.setUpdatedAt(null);
  user.setDeletedAt(null);
  user.setDeleterId(null);

  request.setUser(user);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.upsertUser(request, getRequestMetadata(), (err) => {
      if (err) {
        console.warn("upsertUser", err.code, err.message);
        reject(err);
      } else {
        resolve(true);
      }
    });
  });
};

const deleteUser = ({ organizationId, id }) => {
  const request = new GetUsersRequest();
  request.setOrganizationId(organizationId);
  request.setIdsList([id]);

  return new Promise((resolve, reject) => {
    AUTHER_CLIENT.deleteUser(request, getRequestMetadata(), (err) => {
      if (err) {
        console.warn("deleteUser", err.code, err.message);
        reject(err);
      } else {
        resolve(true);
      }
    });
  });
};

const isSukiUserAdmin = async ({ organizationId, userId }) => {
  const user = await getUsers({ organizationId, userId })[0];
  console.log("user", user);
  // 2. check if user is admin
  // return true/false
};

const convertUserFromProto = (userProto) => {
  return {
    id: userProto[0],
    firstName: userProto[1],
    middleName: userProto[2],
    lastName: userProto[3],
    email: userProto[4],
    role: convertRoleFromProto(userProto[5]),
    organizationId: userProto[6],
    createdAt: convertTimestamp(userProto[7]?.[0]),
    updatedAt: convertTimestamp(userProto[8]?.[0]),
    deletedAt: convertTimestamp(userProto[9]?.[0]),
    deleterId: userProto[10]
  };
};

const convertRoleFromProto = (roleProto) => {
  switch (roleProto) {
    case 0:
      return ROLES.VIEWER;
    case 1:
      return ROLES.ENTERPRISE_ADMIN;
    case 2:
      return ROLES.SUKI_ADMIN;
    case 3:
      return ROLES.VIEWER;
    default:
      return null;
  }
};

const convertRoleToProto = (role) => {
  switch (role) {
    case ROLES.ENTERPRISE_ADMIN:
      return 1;
    case ROLES.SUKI_ADMIN:
      return 2;
    case ROLES.VIEWER:
      return 3;
    default:
      return 1; // default to enterprise admin
  }
};

export {
  convertRoleToProto,
  convertRoleFromProto,
  convertUserFromProto,
  isSukiUserAdmin,
  deleteUser,
  createUser,
  getCachedUsers,
  getCurrentUser,
  getUsers
};
